import styled, { css } from 'styled-components';

import { colors, monokaiBackground, darkModeBackground } from 'global/colors';

export const DiscussionContainer = styled.div`
  padding: 5px;

  ${({ isDarkMode }) =>
    isDarkMode &&
    css`
    & .quill {
      background-color: ${colors.gray2};

      & :is(h1, h2, h3, h4, h5, h6) {
        color: ${colors.black};
      }
    }

    & .darkModeSupport {
      background-color: ${darkModeBackground};
      
      & a {
        color: ${colors.fsCyan};
      }

      & pre {
        background-color: ${monokaiBackground};
        color: ${colors.white};
      }

      & button:hover {
      background-color: ${monokaiBackground};
      
      & :is(.fa-comment-o, .fa-comments-o) {
        color: ${colors.white};
      }
    }
  `}
`;
